import { render, staticRenderFns } from "./CommonDocsModal.Style#Drawer.vue?vue&type=template&id=dd159154&scoped=true&"
import script from "./CommonDocsModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./CommonDocsModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./CommonDocsModal.Style#Drawer.vue?vue&type=style&index=0&id=dd159154&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd159154",
  null
  
)

export default component.exports